




import Vue from 'vue'

interface Breadcrumb {
  path: string
  to: string
  text: string
}

export default Vue.extend({
  computed: {
    crumbs: function() {
      const pathArray = this.$route.path.split('/')
      pathArray.shift()
      const breadcrumbs = pathArray.reduce(
        (breadcrumbArray: Breadcrumb[], path: string, idx: number) => {
          const text = this.$route.matched[idx]
            ? this.$route.matched[idx].meta.breadCrumb || path
            : path
          breadcrumbArray.push({
            path: path,
            to: breadcrumbArray[idx - 1]
              ? '/' + breadcrumbArray[idx - 1].path + '/' + path
              : '/' + path,
            text,
          })
          return breadcrumbArray
        },
        []
      )
      return breadcrumbs
    },
  },
})
